import React, { FC, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SignUpForm from "@components/Onboarding/SignUpForm/SignUpForm";
import SideImageLayout from "@components/SideImageLayout/SideImageLayout";
import { INTRO_SEEN_STORAGE_KEY } from "@constants/intro";

const SignUp: FC = () => {
  const navigate = useNavigate();

  useEffect(() => {
    try {
      const hasSeenIntro = localStorage.getItem(INTRO_SEEN_STORAGE_KEY);
      if (!hasSeenIntro) {
        navigate("/intro", { replace: true });
      }
    } catch {
      // if storage is unavailable, just proceed to sign-up
    }
  }, [navigate]);

  return (
    <SideImageLayout>
      <SignUpForm />
    </SideImageLayout>
  );
};

export default SignUp;
